
{
  "familyId": "MET-OPP-VIERKANT",
  "questions": [
    {
      "id": "MET-OPP-VIERKANT-001",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een vierkant heeft zijden van 6 cm. Wat is de oppervlakte?",
      "context": null,
      "options": ["36 cm²", "24 cm²", "12 cm²", "42 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 6,
            "height": 6,
            "unit": "cm",
            "showGrid": true,
            "label": "Vierkant: 6 × 6 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Formule: oppervlakte = zijde × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 6 × 6 = 36 cm².",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "square_area_basic",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Formule: oppervlakte vierkant = zijde × zijde. Stap 1: De zijde is 6 cm. Stap 2: 6 × 6 = 36. Stap 3: De oppervlakte is 36 cm².",
        "distractorExplanations": {
          "0": "Correct! 6 × 6 = 36 cm².",
          "1": "24 cm² is de omtrek (4 × 6 = 24), niet de oppervlakte. Oppervlakte = zijde × zijde = 6 × 6 = 36 cm².",
          "2": "12 cm² klopt niet. Je hebt misschien 6 × 2 = 12 berekend. Oppervlakte = zijde × zijde = 6 × 6 = 36 cm².",
          "3": "42 cm² klopt niet. Controleer: 6 × 6 = 36, niet 42."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-002",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een vierkante tuin heeft een oppervlakte van 49 m². Hoe lang is elke zijde?",
      "context": null,
      "options": ["7 m", "49 m", "12 m", "14 m"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 7,
            "height": 7,
            "unit": "m",
            "showGrid": true,
            "label": "Vierkante tuin: ? × ? = 49 m²"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Zijde berekenen",
            "content": "Als oppervlakte = zijde × zijde, dan is de zijde = √oppervlakte. √49 = 7. Elke zijde is 7 m.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "square_side_from_area",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: als oppervlakte = zijde × zijde, dan zijde = √oppervlakte. Stap 1: Oppervlakte = 49 m². Stap 2: Welk getal × zichzelf = 49? Stap 3: 7 × 7 = 49. Elke zijde is 7 m.",
        "distractorExplanations": {
          "0": "Correct! √49 = 7, dus elke zijde is 7 m.",
          "1": "49 m is de oppervlakte, niet de zijde. De zijde = √49 = 7 m.",
          "2": "12 m klopt niet. 12 × 12 = 144 m², niet 49 m².",
          "3": "14 m klopt niet. Je hebt misschien 49 ÷ 2 = 24,5 of iets anders berekend. De zijde = √49 = 7 m."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-003",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Wat is de omtrek van een vierkant met zijden van 9 cm?",
      "context": null,
      "options": ["36 cm", "81 cm", "18 cm", "27 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 9,
            "height": 9,
            "unit": "cm",
            "showGrid": false,
            "label": "Vierkant: zijde = 9 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Omtrek vierkant",
            "content": "Formule: omtrek = 4 × zijde. Een vierkant heeft 4 gelijke zijden. Dus: 4 × 9 = 36 cm.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "square_perimeter",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Formule: omtrek vierkant = 4 × zijde. Stap 1: De zijde is 9 cm. Stap 2: 4 × 9 = 36. Stap 3: De omtrek is 36 cm.",
        "distractorExplanations": {
          "0": "Correct! 4 × 9 = 36 cm.",
          "1": "81 cm² is de oppervlakte (9 × 9 = 81), niet de omtrek. Omtrek = 4 × 9 = 36 cm.",
          "2": "18 cm klopt niet. Je hebt misschien 2 × 9 = 18 berekend. Een vierkant heeft 4 zijden: 4 × 9 = 36 cm.",
          "3": "27 cm klopt niet. Je hebt misschien 3 × 9 = 27 berekend. Een vierkant heeft 4 zijden: 4 × 9 = 36 cm."
        }
      }
    },
    {
      "id": "MET-OPP-VIERKANT-004",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "fill_in",
      "question": "Een vierkant heeft zijden van 8 cm. Bereken de oppervlakte in cm².",
      "context": null,
      "options": ["64"],
      "correctAnswer": 0,
      "data": {
        "acceptableAnswers": ["64", "64 cm²"],
        "placeholder": "Typ de oppervlakte...",
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 8,
            "height": 8,
            "unit": "cm",
            "showGrid": true,
            "label": "Vierkant: 8 × 8 cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oppervlakte vierkant",
            "content": "Oppervlakte = zijde × zijde = 8 × 8 = 64 cm².",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "square_area_fill_in",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Oppervlakte = zijde × zijde = 8 × 8 = 64 cm²."
      }
    },
    {
      "id": "MET-OPP-VIERKANT-005",
      "familyId": "MET-OPP-VIERKANT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "opp_vierkant",
      "questionType": "multiple_choice",
      "question": "Een vierkante kamer heeft zijden van 5 meter. Je wilt de vloer betegelen. Tegels kosten €12 per m². Wat kosten de tegels in totaal?",
      "context": null,
      "options": ["€300", "€240", "€60", "€120"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": {
            "shape": "square",
            "width": 5,
            "height": 5,
            "unit": "m",
            "showGrid": true,
            "label": "Kamer: 5 × 5 m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oppervlakte en kosten",
            "content": "Stap 1: Oppervlakte = 5 × 5 = 25 m². Stap 2: Kosten = 25 × €12 = €300.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "square_area_context",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Stap 1: Bereken de oppervlakte: 5 × 5 = 25 m². Stap 2: Bereken de kosten: 25 m² × €12/m² = €300.",
        "distractorExplanations": {
          "0": "Correct! 5 × 5 = 25 m², en 25 × €12 = €300.",
          "1": "€240 klopt niet. Je hebt misschien de omtrek (20 m) × €12 = €240 berekend. Gebruik de oppervlakte: 25 × €12 = €300.",
          "2": "€60 klopt niet. Je hebt misschien 5 × €12 = €60 berekend. Je moet de oppervlakte gebruiken: 5 × 5 = 25, dan 25 × €12 = €300.",
          "3": "€120 klopt niet. Je hebt misschien 10 × €12 = €120 berekend. De oppervlakte is 25 m²: 25 × €12 = €300."
        }
      }
    }
  ]
}
